fragment FullWidthAutoplayVideoFragment on fullWidthAutoplayVideo_Entry {
  typeHandle
  preview {
    ...CraftAssetFragment
  }
  video {
    ...CraftAssetFragment
  }
  textOverlay: heading
}
